export default {
	'add-visit': 'Add visit',
	'edit-visit': 'Edit visit',
	'visit-is-created': 'Visit is created',
	'visit-is-updated': 'Visit is updated',
	'the-visit': 'the visit',
	'daily-report': 'Daily Report',
	'report-type': {
		important: 'Important',
		complaint: 'Complaint',
		'normal-note': 'Normal note',
	},
	'daily-report-is-updated': 'Daily report is updated',
	'no-visits-to-show': 'NO VISITS TO SHOW',
	'visit-details': 'Visit details',
	total: 'Total',
	remaining: 'Remaining',
	'insufficient-material-balance': 'You cannot add this material, you do not have enough balance of it',
	'amount-exceeds-remaining': 'Amount cannot exceed the remaining balance ({limit})',

	'balance-update': 'Balance update',
	'balance-update-error': 'Something goes wrong on updating balance, please click "update" to update the balance',

	'tab-scientific': 'Scientific',
	'tab-commercial': 'Commercial',
	'tab-marketing': 'Marketing',
	'create-order': 'Create order',
	'order-items': 'Order items',
	order: 'Order',
	'order-id': 'Order ID',
	'order-details': 'Order details',
	'no-order-items': 'No order items',
	'order-delivery-date-without-items': 'Please add order items or clear the delivery date to save.',
	'add-plan-materials': 'Add plan materials',
	'remove-plan-materials': 'Remove plan materials',
}